var _rect, _path, _path2, _path3, _circle, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2945 16.3077C17.3141 16.3077 18.1407 15.4811 18.1407 14.4615C18.1407 13.4419 17.3141 12.6154 16.2945 12.6154C15.2749 12.6154 14.4484 13.4419 14.4484 14.4615C14.4484 15.4811 15.2749 16.3077 16.2945 16.3077ZM16.2945 17.9231C18.2063 17.9231 19.7561 16.3733 19.7561 14.4615C19.7561 12.5498 18.2063 11 16.2945 11C14.3828 11 12.833 12.5498 12.833 14.4615C12.833 16.3733 14.3828 17.9231 16.2945 17.9231Z",
    fill: "#0A33FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7378 21.3855H19.8513C19.6688 20.3547 19.3092 19.5058 18.7957 18.9246C18.2889 18.3509 17.5373 17.924 16.2945 17.924C15.0518 17.924 14.3002 18.3509 13.7934 18.9246C13.2799 19.5058 12.9202 20.3547 12.7378 21.3855ZM12.6009 21.3855C12.6002 21.3855 12.5999 21.3854 12.5999 21.3854L12.6009 21.3855ZM11.1007 21.3909C11.4897 18.7385 12.9325 16.3086 16.2945 16.3086C19.6566 16.3086 21.0993 18.7385 21.4883 21.3909C21.6178 22.2736 20.879 23.0009 19.9868 23.0009H12.6022C11.7101 23.0009 10.9713 22.2736 11.1007 21.3909Z",
    fill: "#0A33FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0002 15.7992H19.0002V14.1992H26.0002C27.5466 14.1992 28.8002 15.4528 28.8002 16.9992V24.9992C28.8002 26.5456 27.5466 27.7992 26.0002 27.7992H17.0002C15.4538 27.7992 14.2002 26.5456 14.2002 24.9992V22.9992H15.8002V24.9992C15.8002 25.662 16.3375 26.1992 17.0002 26.1992H26.0002C26.6629 26.1992 27.2002 25.662 27.2002 24.9992V16.9992C27.2002 16.3365 26.6629 15.7992 26.0002 15.7992Z",
    fill: "#0A33FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 19,
    r: 1,
    fill: "#0A33FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0996,
    y: 20.4609,
    width: 1.84615,
    height: 3.54,
    fill: "#0A33FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirector);
export default __webpack_public_path__ + "static/media/director.d410c3256672a7c990d57223fdb66679.svg";
export { ForwardRef as ReactComponent };